import { Component, OnInit } from '@angular/core';
import { AppContextService } from '../../services/app-context.service';
import { User } from '../../models/User/user';
import { TranslateService } from '../../services/translate/translate.service';

interface NewFeatureLink {
	label: string;
	date: string | null;
	fileName: string | null;
	url: string;
}

const NEW_FEATURES_DOCS_PATH = 'assets/docs/FlexcashInformation_';
const NEW_FEATURES_SUPPORTED_LANGUAGES = ['en', 'pt', 'es'];
const NEW_FEATURES_FALLBACK_LANGUAGE = 'en';

@Component({
	selector: 'app-private-home',
	templateUrl: './private-home.component.html',
	styleUrls: ['./private-home.component.scss'],
	standalone: false,
})
export class PrivateHomeComponent implements OnInit {
	public loggedUser: User | null = new User();
	public newFeature: NewFeatureLink | null = null;

	constructor(
		private appContext: AppContextService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.loggedUser = this.appContext.getLoggedUser() ?? new User();
		this.newFeature = this.buildNewFeatureLink();
	}

	private buildNewFeatureLink(): NewFeatureLink | null {
		const label = this.getResource('home.newfeatures.linkText');
		if (!label) return null;

		const date = this.getResource('home.newfeatures.date');
		const fileName = this.getResource('home.newfeatures.documentName');
		const languageCode = (this.loggedUser?.LanguageCode ?? '').toLowerCase();
		const docLanguage = NEW_FEATURES_SUPPORTED_LANGUAGES.includes(languageCode) ? languageCode : NEW_FEATURES_FALLBACK_LANGUAGE;
		const version = date ? `?v=${encodeURIComponent(date)}` : '';

		return {
			label,
			date,
			fileName,
			url: `${NEW_FEATURES_DOCS_PATH}${docLanguage.toUpperCase()}.pdf${version}`,
		};
	}

	// The translate service returns the lowercased key itself when a resource does not exist.
	private getResource(key: string): string | null {
		const value = this.translateService.translateByLanguage(key, this.loggedUser?.LanguageCode, 'client');
		return !value || value === key.toLowerCase() ? null : value;
	}
}
